import { GetServerSidePropsContext, GetServerSidePropsResult } from 'next';

import ListCollection from 'types/redux/ListCollection';

import Article from 'models/Article';

import { LIST_MARKUP } from 'consts/api';
import { fillPage } from 'utils/translations';

import { list as listArticles } from 'requests/articles';

import Component from './component';
import { Props } from './types';

export async function getServerSideProps(context: GetServerSidePropsContext): Promise<GetServerSidePropsResult<Props>> {
    let articles: ListCollection<Article> = LIST_MARKUP;

    try {
        await Promise.all([
            listArticles({ page: 1, perPage: 7 }),
        ]).then(responses => {
            articles = responses[0]?.articles;
        });
    } catch (error) {
        console.error(error);
    }

    let pageTranslations = JSON.parse(JSON.stringify(require('locales/pl/pages/blog')?.default));
    const fillValues = {};
    pageTranslations = fillPage(pageTranslations, null, fillValues);

    return {
        props: {
            pageTranslations,
            articles: JSON.parse(JSON.stringify(articles)),
        },
    };
}

export default Component;

